import React, { Component } from 'react'
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  Button,
  withStyles
} from '@material-ui/core'
import { useForm, Form, Field } from '../../form'

const styles = (theme) => ({
  textArea: {
    fontSize: '15px',
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(1),
    lineHeight: '16px'
  },
  tableCell: {
    border: 'none'
  }
})

class AdminUpdateForm extends Component {
  render() {
    return <AdminUpdateFormComponent {...this.props} />
  }
}

export default withStyles(styles)(AdminUpdateForm)

const AdminUpdateFormComponent = ({ classes, adminAddNewUpdates }) => {
  const form = useForm({
    name: 'adminUpdates',
    onSubmit: onSubmit,
    defaultValues: { company_update: '' }
  })

  const { control } = form

  function onSubmit(values) {
    adminAddNewUpdates(values)
  }

  return (
    <Form {...form}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell className={classes.tableCell}>
              <Field
                name="company_update"
                inputType="textfield"
                control={control}
                className={classes.textArea}
                label="Päivitä"
                multiline
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCell}>
              <Button variant="contained" className="pull-right" type="submit">
                Tallenna
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Form>
  )
}
